export default __webpack_public_path__ + "static/media/DiaAward.71dccc19.png";